import { stringToMoment } from '../../../utils/dateUtils';

export const TREES_PAYMENT_MODAL_ENABLED = true;
export const TREES_PAYMENT_COOKIE_PREFIX = 'trees-payment-modal';
export const TREES_PAYMENT_MODAL_MAXIMUM_DISPLAY = 2;
export const TREES_PAYMENT_MODAL_PERIOD_DURATION_DAYS = 14;
export const TREES_PAYMENT_MODAL_START_DATE = stringToMoment('2025-10-24 00:00:00');
export const TREES_PAYMENT_MODAL_END_DATE = stringToMoment('2025-11-14 23:59:59');



// WEBPACK FOOTER //
// ./src/services/modal/TreesPaymentModal/constants.js